import { CommunityPost, Comment, PostDetailResponse, CommentsResponse, CommentCreateRequest } from '../types/community';
import { apiClient } from '.';

// 게시글 상세 조회
export const fetchPostDetail = async (postId: number): Promise<PostDetailResponse> => {
  try {
    const { data } = await apiClient.get<PostDetailResponse>(
      `/api/community/posts/${postId}`
    );
    return data;
  } catch (error) {
    /// console.error('게시글 상세 조회 실패:', error);
    throw error;
  }
};

// 게시글 댓글 목록 조회
export const fetchPostComments = async (
  postId: number, 
  page: number = 0, 
  size: number = 20
): Promise<CommentsResponse> => {
  try {
    const { data } = await apiClient.get<CommentsResponse>(
      `/api/community/posts/${postId}/comments`,
      { params: { page, size } }
    );
    return data;
  } catch (error) {
    /// console.error('댓글 목록 조회 실패:', error);
    throw error;
  }
};

// 댓글 작성
export const createComment = async (commentData: CommentCreateRequest): Promise<any> => {
  try {
    const formData = new FormData();
    formData.append('postId', commentData.postId.toString());
    formData.append('content', commentData.content);
    
    if (commentData.parentId) {
      formData.append('parentId', commentData.parentId.toString());
    }
    
    if (commentData.files) {
      commentData.files.forEach(file => {
        formData.append('files', file);
      });
    }

    const { data } = await apiClient.post(
      `/api/community/comments`,
      formData
    );
    return data;
  } catch (error) {
    /// console.error('댓글 작성 실패:', error);
    throw error;
  }
};

// 게시글 조회수 증가
export const increasePostViewCount = async (postId: number): Promise<void> => {
  try {
    await apiClient.post(`/api/community/posts/${postId}/view`);
  } catch (error) {
    /// console.error('조회수 증가 실패:', error);
    // 조회수 증가 실패는 치명적이지 않으므로 에러를 던지지 않음
  }
};

// 커뮤니티 게시글 카테고리 목록 조회
export interface CommunityCategory {
  id: number;
  name: string;
  description?: string;
}

export interface CommunityCategoriesResponse {
  code: number;
  message: string;
  data: CommunityCategory[];
}

export const getCommunityCategories = async (): Promise<CommunityCategoriesResponse> => {
  try {
    // 실제 유저 커뮤니티용 카테고리 API가 있다면 해당 엔드포인트를 사용
    // 없다면 관리자용 API를 사용하되, 유저가 접근 가능한지 확인 필요
    const { data } = await apiClient.get<CommunityCategoriesResponse>(
      `/api/post-categories/list`,
      { withCredentials: true }
    );
    /// console.log('포스트 카테고리 API 응답', {data});
    return data;
  } catch (error) {
    /// console.error('커뮤니티 카테고리 목록 조회 실패:', error);
    
    // API가 실패하면 기본 카테고리 목록 반환
    const defaultCategories: CommunityCategoriesResponse = {
      code: 200,
      message: 'success',
      data: [
        { id: 1, name: '공지사항' },
        { id: 2, name: '강의 질문' },
        { id: 3, name: '정보 공유' },
        { id: 4, name: '자유' },
        { id: 5, name: '스터디' },
        { id: 6, name: '커피챗' },
        { id: 7, name: '문의하기' },
        { id: 8, name: '아카이브' }
      ]
    };
    
    /// console.log('기본 카테고리 목록 사용(더미):', defaultCategories);
    return defaultCategories;
  }
};
